/**
 * Enhanced Email Service with Error Handling
 */

const DREAMLIT_API_KEY = import.meta.env.VITE_DREAMLIT_API_KEY;
const DREAMLIT_ENDPOINT = 'https://api.dreamlit.ai/v1/send';

export const sendDreamlitEmail = async (templateId, recipient, data) => {
  // Check if we are using the placeholder key
  if (!DREAMLIT_API_KEY || DREAMLIT_API_KEY === 'your_dreamlit_api_key_here') {
    console.warn(`[System] Mocking email: Template "${templateId}" to ${recipient}. Please set VITE_DREAMLIT_API_KEY in .env`);
    return { success: true, mocked: true };
  }

  try {
    const response = await fetch(DREAMLIT_ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${DREAMLIT_API_KEY}`
      },
      body: JSON.stringify({
        template_id: templateId,
        to: recipient,
        data: {
          ...data,
          app_name: "Elk Grove Airline Wait",
          site_url: window.location.origin
        }
      })
    });

    if (response.status === 429) {
      throw new Error("Daily notification limit reached. Please try again tomorrow.");
    }

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || "Failed to send notification.");
    }

    return await response.json();
  } catch (error) {
    console.error('[System] Notification Error:', error.message);
    throw error;
  }
};

export const sendTripShareEmail = (data) => 
  sendDreamlitEmail('trip_share_notification', data.receiver_email, data);